export default __webpack_public_path__ + "static/media/information--minimum-speed-75--g1.4939a840.png";